import { Form, Input, message, Select, Table, TimePicker } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import deleteSvg from "../../../../../assets/svg/delete-red.svg";
import svg80 from "../../../../../assets/svg/svg80.svg";
import svg59 from "../../../../../assets/svg/svg59.svg";
import svg85 from "../../../../../assets/svg/svg85.svg";
import svg92 from "../../../../../assets/svg/svg92.svg";
import addSvg from "../../../../../assets/svg/add-dark.svg";
import useModalToggle from "../../../../../custom_hooks/useModalToggle";
import {
  deleteDoc,
  setDocsObj,
} from "../../../../../features/folder/folderSlice";
import { saveFile } from "../../../../../features/auth/authSlice";
import Dragger from "antd/es/upload/Dragger";
import toast from "react-hot-toast";
import { formatPathJpa, previewPaperApplicant } from "../../../../../utils";

const EditableCell = ({
  editing,
  dataIndex,
  title,
  inputType,
  record,
  children,
  form,
  dispatch,
  setDataSource,
  dataSource,
  ...restProps
}) => {
  let inputNode;

  if (inputType === "file") {
    inputNode = (
      <Dragger
        name="file"
        multiple={false}
        accept="*"
        showUploadList={false}
        beforeUpload={async (file) => {
          const formData = new FormData();
          formData.append("file", file);

          try {
            const res = await dispatch(saveFile(formData));
            if (res?.payload?.success) {
              toast.success(res?.payload?.messages?.message);
              const serverFileName = res.payload?.data?.result;

              form.setFieldsValue({ [dataIndex]: serverFileName });

              const updatedDocs = dataSource.map((row) =>
                row?.mbiId === record?.mbiId
                  ? { ...row, [dataIndex]: serverFileName }
                  : row
              );
              dispatch(setDocsObj(updatedDocs));
            } else {
              message.error(
                `Upload failed: ${res?.payload?.messages?.message}`
              );
              form.setFieldsValue({ [dataIndex]: "" });
            }
          } catch (err) {
            message.error("Upload failed");
            console.error(err);
          }
          return false;
        }}
      >
        {record?.docFile ? (
          <a
            href={record.mbiFileUrl || "#"}
            target="_blank"
            rel="noopener noreferrer"
          >
            {record.docFile}
          </a>
        ) : (
          <p className="ant-upload-text">Click or drag file to upload</p>
        )}
      </Dragger>
    );
  } else if (inputType === "dropdown") {
    inputNode = (
      <Select
        suffixIcon={
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="21"
            height="21"
            viewBox="0 0 21 21"
            fill="none"
          >
            <path
              d="M17.1922 8.21268L10.9422 14.4627C10.8841 14.5208 10.8152 14.5669 10.7393 14.5983C10.6634 14.6298 10.5821 14.646 10.5 14.646C10.4178 14.646 10.3365 14.6298 10.2606 14.5983C10.1848 14.5669 10.1158 14.5208 10.0578 14.4627L3.80779 8.21268C3.69052 8.0954 3.62463 7.93634 3.62463 7.77049C3.62463 7.60464 3.69052 7.44558 3.80779 7.3283C3.92507 7.21103 4.08413 7.14514 4.24998 7.14514C4.41583 7.14514 4.57489 7.21103 4.69217 7.3283L10.5 13.1369L16.3078 7.3283C16.3659 7.27023 16.4348 7.22417 16.5107 7.19274C16.5865 7.16132 16.6679 7.14514 16.75 7.14514C16.8321 7.14514 16.9134 7.16132 16.9893 7.19274C17.0652 7.22417 17.1341 7.27023 17.1922 7.3283C17.2502 7.38637 17.2963 7.45531 17.3277 7.53118C17.3592 7.60705 17.3753 7.68837 17.3753 7.77049C17.3753 7.85261 17.3592 7.93393 17.3277 8.0098C17.2963 8.08567 17.2502 8.15461 17.1922 8.21268Z"
              fill="#212121"
            />
          </svg>
        }
        // options={mngrCrops?.map((item, index) => {
        //   return {
        //     label: (
        //       <div key={index}>
        //         <span>{item?.cropName}</span>
        //       </div>
        //     ),
        //     value: item?.cropName,
        //   };
        // })}
      />
    );
  } else if (inputType === "time") {
    inputNode = <TimePicker format="HH:mm" className="w-full input" />;
  } else {
    inputNode = <Input className="input" placeholder={`Enter ${title}`} />;
  }

  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          name={dataIndex}
          style={{ margin: 0 }}
          rules={[{ required: true, message: `${title} is required` }]}
        >
          {inputNode}
        </Form.Item>
      ) : dataIndex === "docFile" ? (
        record?.docFile ? (
          record.docFile
        ) : (
          "-"
        )
      ) : (
        children
      )}
    </td>
  );
};

export default function DocumentEditableTable({
  handleSubmitStep,
  handlePrev,
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const { open, handleCancel, handleOpen } = useModalToggle();
  const [prodd, setProdd] = useState();
  const showDrawer = async (item) => {
    await setProdd(item);
    await handleOpen();
  };
  const onClose = () => {
    handleCancel();
  };
  const { activeObjJob } = useSelector((state) => ({
    activeObjJob: state.folder.activeObj["job"],
  }));

  const { rowId, selectedCandidates } = useSelector((state) => state.folder);
  const { docs } = useSelector((state) => state.folder);
  const dataSource = docs || [];

  useEffect(() => {
    if (activeObjJob?.jobDocs?.length && docs?.length === 0) {
      const mapped = activeObjJob?.jobDocs?.map((doc, idx) => ({
        mbiId: Date.now() + idx,
        docName: doc,
        docFile: null,
      }));
      dispatch(setDocsObj(mapped));
    }
  }, [activeObjJob?.jobDocs]);

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [editingKey, setEditingKey] = useState("");

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const isEditing = (record) => record?.mbiId === editingKey;

  const edit = (record) => {
    form.setFieldsValue({
      ...record,
    });
    setEditingKey(record?.mbiId);
  };

  const cancel = async (record) => {
    const isRowEmpty = !record?.docName && !record?.docFile;

    if (isRowEmpty) {
      const updatedDocs = docs?.filter((item) => item?.mbiId !== record?.mbiId);
      dispatch(setDocsObj(updatedDocs));
    }

    await setEditingKey("");
  };

  const saveFunction = async (key) => {
    try {
      const row = await form.validateFields();
      const newData = [...dataSource];
      const index = newData.findIndex((item) => key === item?.mbiId);

      if (index > -1) {
        const item = newData[index];
        const { docFile, ...restRow } = row;

        const updatedObj = {
          ...item,
          ...restRow,
        };
        newData.splice(index, 1, updatedObj);
        // const cleaned = newData?.map(({ mbiId, ...rest }) => rest);
        dispatch(setDocsObj(newData));
        setEditingKey("");
      }
    } catch (errInfo) {
      console.log("Validate Failed:", errInfo);
    }
  };

  const handleAdd = () => {
    const lastRow = dataSource[dataSource.length - 1];
    if (
      lastRow &&
      (!lastRow.docName || !lastRow.docFile || editingKey === lastRow.mbiId)
    ) {
      return;
    }

    const newId = Date.now();
    const newRow = {
      mbiId: newId,
      docName: "",
      docFile: null,
    };

    // setDataSource([...dataSource, newRow]);
    setEditingKey(newId);

    setTimeout(() => {
      form.setFieldsValue({
        docName: "",
        docFile: null,
      });
    }, 100);
  };

  const handleRemove = () => {
    const updatedData = dataSource.filter(
      (item) => !selectedRowKeys.includes(item.mbiId)
    );
    // setDataSource(updatedData);
    setSelectedRowKeys([]);
  };

  const handleDeleteRow = () => {
    const updatedData = dataSource.filter(
      (item) => !selectedRowKeys.includes(item.mbiId)
    );

    // setDataSource(updatedData);

    setSelectedRowKeys([]);

    if (selectedRowKeys.includes(editingKey)) {
      setEditingKey("");
    }

    const cleaned = updatedData?.map(({ mbiId, ...rest }) => rest);
    dispatch(setDocsObj(cleaned));
  };

  // const handleDeleteSingleRow = (record) => {
  //   setDataSource((prev) =>
  //     prev?.filter((item) => item?.mbiId !== record?.mbiId)
  //   );
  //   dispatch(deleteDoc(record.mbiId));

  //   if (editingKey === record?.mbiId) {
  //     setEditingKey("");
  //   }
  // };

  const defaultColumns = [
    {
      title: "#",
      dataIndex: "index",
      width: "3%",
      render: (_, __, index) => index + 1,
    },
    {
      title: "Name",
      dataIndex: "docName",
    },
    {
      title: "File",
      dataIndex: "docFile",
      render: (item) => {
        return <div>{formatPathJpa(item)}</div>;
      },
      editable: true,
    },
    {
      title: "Action",
      dataIndex: "action",
      render: (_, record) => {
        const editable = isEditing(record);

        const candidateCount =
          selectedCandidates?.filter(
            (item) => item?.japInterviewSession === record?.docName
          )?.length || 0;

        return editable ? (
          <div className="flex w-fit items-center gap-[1rem]">
            <button
              onClick={() => cancel(record)}
              className="modal_btn_light"
              type="button"
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={() => saveFunction(record?.mbiId)}
              className="modal_btn_dark"
            >
              Save
            </button>
          </div>
        ) : (
          <div className="flex items-center gap-3">
            <img
              src={svg80}
              alt="svg80"
              className="cursor-pointer"
              onClick={() => edit(record)}
            />
            {record?.docFile && (
              <>
                <img
                  src={svg59}
                  alt="svg59"
                  className="cursor-pointer"
                  onClick={() => previewPaperApplicant(record?.docFile)}
                />

                {/* <img
                  src={deleteSvg}
                  alt="deleteSvg"
                  className="cursor-pointer"
                  onClick={() => handleDeleteSingleRow(record)}
                /> */}
              </>
            )}
          </div>
        );
      },
    },
  ];

  const mergedColumns = defaultColumns?.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record) => ({
        record,
        dataIndex: col.dataIndex,
        inputType:
          col.dataIndex === "docNamesdsdd"
            ? "dropdown"
            : col.dataIndex === "docFile"
            ? "file"
            : "text",
        title: col.title,
        editing: isEditing(record),
      }),
    };
  });

  return (
    <>
      <div className={`text-lightBlack text-[1.125rem] font-dmSans font-500`}>
        Other Relevant Documents
      </div>

      <div className="grid grid-cols-1  mt-[1rem]">
        <div className="max-w-full w-full overflow-x-auto">
          <Form form={form} component={false}>
            <Table
              className="editable_table"
              size="large"
              bordered={false}
              rowSelection={false}
              columns={mergedColumns}
              components={{
                body: {
                  cell: (props) => (
                    <EditableCell
                      {...props}
                      form={form}
                      dispatch={dispatch}
                      // setDataSource={setDataSource}
                      dataSource={dataSource}
                    />
                  ),
                },
              }}
              dataSource={dataSource}
              rowKey="mbiId"
              pagination={{
                defaultPageSize: 10,
                hideOnSinglePage: true,
                pageSizeOptions: [10, 20, 50, 100],
              }}
              // footer={() => (
              //   <div className="flex items-center w-full justify-between gap-[1.25rem] p-[1rem]">
              //     {selectedRowKeys.length > 0 ? (
              //       <button
              //         type="button"
              //         onClick={handleDeleteRow}
              //         className="flex items-center gap-[.5rem]"
              //       >
              //         <img src={deleteSvg} alt="deleteSvg" />

              //         <span className="role_btn_text !text-[#C72C3B]">
              //           Remove selected
              //         </span>
              //       </button>
              //     ) : (
              //       <button
              //         type="button"
              //         onClick={handleAdd}
              //         disabled={dataSource?.some(
              //           (item) => !item?.docName || !item?.docFile
              //         )}
              //         className="flex items-center gap-[.5rem]"
              //       >
              //         <div className="w-[2.5rem] h-[2.5rem] border border-[#0B363D] rounded-[.6875rem] flex items-center justify-center">
              //           <img src={addSvg} alt="addSvg" />
              //         </div>
              //         <span className="text-[#0E0E0E] text-[.875rem] font-[400] font-dmSans">
              //           Add
              //         </span>
              //       </button>
              //     )}
              //   </div>
              // )}
            />
          </Form>
        </div>
      </div>

      <div className="flex lg:flex-row flex-col lg:items-center justify-between lg:gap-0  gap-5   w-full mt-[2.5rem]">
        <div
          className="flex items-center text-[#706F6F] text-[.875rem] font-[400] font-dmSans gap-3 cursor-pointer"
          onClick={handlePrev}
        >
          <img src={svg85} alt="svg85" /> Back
        </div>
        <div className="justify-end flex items-center gap-x-2">
          <div className="w-[100px]">
            <button
              key="back"
              type="button"
              className="cstm-btn-2"
              onClick={handlePrev}
            >
              Cancel
            </button>
          </div>

          <div className="w-[250px]">
            <button
              key="submit"
              type="submit"
              className="cstm-btn"
              onClick={handleSubmitStep}
            >
              <span className="flex items-center  gap-x-3 ">
                Save And Proceed <img src={svg92} alt="svg92" />
              </span>
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
